import { PAGE_ENTER_DEFAULT_STYLE, PAGE_EXIT_DEFAULT_STYLE, PAGE_STYLE } from '../page'
import router, { IRouteParams } from '../../../base/lib/router'
import { Base } from '../../../base/components/base'
import ldb from '../../../base/lib/ldb'
import { Div } from '../../../base/components/native/div'
import { ConfirmList } from './confirm-list'
import { SearchUsers } from './search-users'
import { waitFor } from '../../../base/utils/wait'
import { UserOperation } from './user-operation'
import {emitter} from '../../../base/utils/emitter'

export const CashbackPage = () => {
    const base = Base()
    const contents = Div('')
    const header = Div('مشاهده و به روزرسانی امتیازها')
    const searchUsers = SearchUsers()
    const userOperations = UserOperation()
    const confirmList = ConfirmList()
    contents.append(confirmList, userOperations, searchUsers)

    // const tweak = Tweak()

    base.cssClass({ ...PAGE_STYLE, direction: 'rtl', padding: '20px 60px' })

    let _current: any = null
    searchUsers.on('user-selected', (user: any) => {
        console.log('user selected', user)
        _current = user
        userOperations.fill(user)
    })
    // emitter.on('confirm-cashback', (user: any) => {
    //     if (user.email === _current) {
    //         userOperations.fill(user)
    //     }
    // })

    base.append(header, contents)
    header.cssClass({
        fontSize: '20px',
        marginBottom: '20px',
    })
    contents.cssClass({
        display: 'flex',
        flexDirection: 'row',
    })

    return Object.assign(base, {
        async enter() {
            if (!ldb.get('DANESH_FX_ADMIN_TOKEN')) {
                setTimeout(() => {
                    router.goto('/login')
                }, 500)
            }
            await waitFor(200)
            base.style(PAGE_ENTER_DEFAULT_STYLE)
        },
        exit() {
            base.style(PAGE_EXIT_DEFAULT_STYLE)
        }
    })
}